'use strict';

// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
  if (!Array.isArray(array)) {
    return undefined;
  }

  for (var i = 0; i < array.length; i++) {
    if (comparator(array[i])) {
      return array[i];
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/functions/find.js
// module id = 10
// module chunks = 0